const typeFields = {
  photo: {
    type: 'photo',
    src: ''
  },
  record: {
    type: 'record',
    src: ''
  },
  video: {
    type: 'video',
    src: '',
    cover: ''
  },
  qrcode: {
    type: 'qrcode',
    image_url: '',
    src: '',
    data: '',
    status: '',
  },
}

/**
 * 添加图片、录音、视频到文件列表
 * @param {Array} source
 * @param {object|string} data
 * @param {string|number} index
 */

export function addFile (source, data, index) {
  let $data = {}
  // 获得 file 数据模型
  if (typeFields[data.type]) {
    for (let field in typeFields[data.type]) {
      if (typeFields[data.type].hasOwnProperty(field)) {
        $data[field] = data[field]
      }
    }
  } else {
    $data = data
  }
  if (index !== undefined) {
    source.splice(index, 0, $data)
  } else {
    source.push($data)
  }
}

/**
 * 删除文件
 * @param {Array} source
 * @param {string|number} index
 */
export function deleteFile (source, index) {
  // 删除
  source.splice(index, 1)
}

/**
 * 改变文件顺序
 * @param {Array} source
 * @param {string|number} index
 * @param {string|number} newIndex
 */
export function changeFileIndex (source, index, newIndex) {
  // 获得数据
  let data = source[index]
  // 删除数据
  deleteFile(source, index)
  // 还原数据到新的位置
  addFile(source, data, newIndex)
}



// WEBPACK FOOTER //
// ./src/views/question-review/lib/file.js